import { Spin } from "antd";
import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useAppDispatch } from "../../store";
import { fetchUser } from "../../store/slices/user";
import useCurrentUser from "../../hooks/useCurrentUser";

const MainRoute = () => {
  const dispatch = useAppDispatch();
  const { data, isLoading } = useCurrentUser();
  useEffect(() => {
    dispatch(fetchUser());
  }, [dispatch]);

  return (
    <>
      {isLoading ? <Spin spinning fullscreen /> : null}
      {data ? <Outlet/> : null}
    </>
  );
};

export default MainRoute;
